/* eslint no-underscore-dangle: 0 */
import React from 'react';

import { ExternalLink } from 'features/order-tracker/shared-components';
import { TRACKING_DELIVERY_DETAILS_FAILED } from 'features/order-tracker/store/sagas/services/helpers/constants';
import {
  APPOINTMENT_STATUSES,
  DELIVERY_STATUSES,
  SERVICE_ACTIVATION_PRODUCT_STATUSES,
} from 'features/order-tracker/utils/entries';

import {
  APPOINTMENT_AWAITING_CONFIRMATION,
  APPOINTMENT_ENGINEER_UNABLE_TO_COMPLETE,
  APPOINTMENT_SCHEDULED_DATE,
  APPOINTMENT_SUPPLIER_DELAYED,
  APPOINTMENT_SUPPLIER_WAS_UNABLE_TO_ATTEND,
  APPOINTMENT_TOOK_PLACE,
  BY_PHONE_LINK_TEXT,
  BY_PHONE_LINK_URL,
  DELIVERY_DELIVERED,
  DELIVERY_DETAILS_FAILED_INFO,
  DELIVERY_EXPECTED,
  SETUP_GUIDE_LINK_ANALYTICS,
  SETUP_GUIDE_LINK_TEXT,
  SETUP_GUIDE_LINK_URL,
  _SERVICE_ACTIVATION_MESSAGE_,
} from './constants';

import styles from './styles.module.scss';

export const MilestoneMessageBlock: React.FC<components.MilestoneMessageBlock> = ({ status, formattedDate, title }) => {
  switch (status) {
    case APPOINTMENT_STATUSES.Booked:
      return (
        <p>
          {APPOINTMENT_AWAITING_CONFIRMATION}
          <strong>{formattedDate}</strong>
        </p>
      );
    case APPOINTMENT_STATUSES.Confirmed:
    case APPOINTMENT_STATUSES.AtRisk:
    case APPOINTMENT_STATUSES.Rejected:
    case APPOINTMENT_STATUSES.SupplierChanged:
      return (
        <p>
          {APPOINTMENT_SCHEDULED_DATE}
          <strong>{formattedDate}</strong>
        </p>
      );
    case APPOINTMENT_STATUSES.CustomerMissed:
    case APPOINTMENT_STATUSES.ReAppointEUMissed:
      return (
        <p>
          {APPOINTMENT_ENGINEER_UNABLE_TO_COMPLETE}
          <strong>{formattedDate}</strong>
        </p>
      );
    case APPOINTMENT_STATUSES.SupplierMissed:
    case APPOINTMENT_STATUSES.ReAppointORMissed:
      return (
        <p>
          {APPOINTMENT_SUPPLIER_WAS_UNABLE_TO_ATTEND}
          <strong>{formattedDate}</strong>
        </p>
      );
    case APPOINTMENT_STATUSES.SupplierDelayed:
      return (
        <p>
          {APPOINTMENT_SUPPLIER_DELAYED}
          <strong>{formattedDate}</strong>
        </p>
      );
    case APPOINTMENT_STATUSES.Closed:
    case APPOINTMENT_STATUSES.Completed:
      return (
        <p>
          {APPOINTMENT_TOOK_PLACE}
          <strong>{formattedDate}</strong>
        </p>
      );
    case DELIVERY_STATUSES.Dispatched:
    case DELIVERY_STATUSES.InProgress:
      return (
        <p>
          {DELIVERY_EXPECTED}
          <strong>{formattedDate}</strong>
        </p>
      );
    case DELIVERY_STATUSES.Delivered:
      return (
        <p>
          {DELIVERY_DELIVERED}
          <strong>{formattedDate}</strong>
        </p>
      );
    case TRACKING_DELIVERY_DETAILS_FAILED:
      return (
        <p>
          <strong>{DELIVERY_DETAILS_FAILED_INFO.title}</strong>
          <br />
          {DELIVERY_DETAILS_FAILED_INFO.text[0]}
          <strong>{DELIVERY_DETAILS_FAILED_INFO.text[1]}</strong>
          {DELIVERY_DETAILS_FAILED_INFO.text[2]}
          <ExternalLink link={BY_PHONE_LINK_URL} text={BY_PHONE_LINK_TEXT} withIcon={false} className={styles.link} />
        </p>
      );
    case SERVICE_ACTIVATION_PRODUCT_STATUSES.BBProductIncomplete:
    case SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAppointmentIncomplete:
    case SERVICE_ACTIVATION_PRODUCT_STATUSES.CVEProductIncomplete:
      return (
        <>
          <div style={{ marginBottom: '12px' }}>
            Scheduled date: <strong>{formattedDate}</strong>
          </div>
          <p>
            {_SERVICE_ACTIVATION_MESSAGE_[status]}
            {_SERVICE_ACTIVATION_MESSAGE_.common}
          </p>
        </>
      );
    case SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAndCVEIncomplete:
    case SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAppointmentAndCVEIncomplete:
      return (
        <>
          <div style={{ marginBottom: '12px' }}>
            Scheduled date: <strong>{formattedDate}</strong>
          </div>
          {title?.includes('Broadband') ? <p>
            {_SERVICE_ACTIVATION_MESSAGE_[status]}
            {_SERVICE_ACTIVATION_MESSAGE_.common}
          </p> : ''}
        </>
      );

    case SERVICE_ACTIVATION_PRODUCT_STATUSES.BBProductCompleted:
    case SERVICE_ACTIVATION_PRODUCT_STATUSES.CVEProductCompleted:
    case SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAppointmentCompleted:
      return (
        <>
          {formattedDate !== "Monday 1 January 2001" ?
            <div style={{ marginBottom: '12px' }}>
              Service went live: <strong>{formattedDate}</strong>
            </div>:<span />
          }
          <p>
            {_SERVICE_ACTIVATION_MESSAGE_[status]}
            {_SERVICE_ACTIVATION_MESSAGE_.common}
            <ExternalLink
              className={styles.link}
              link={SETUP_GUIDE_LINK_URL}
              withIcon={false}
              text={SETUP_GUIDE_LINK_TEXT}
              analytics={SETUP_GUIDE_LINK_ANALYTICS}
            />
          </p>
        </>
      );

    case SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAppointmentAndCVECompleted:
    case SERVICE_ACTIVATION_PRODUCT_STATUSES.BBAndCVECompleted:
      return (
        <>
          {formattedDate !== "Monday 1 January 2001" ?
            <div style={{ marginBottom: '12px' }}>
              Service went live: <strong>{formattedDate}</strong>
            </div>:<span />
          }
          <p>
            {/* {_SERVICE_ACTIVATION_MESSAGE_[status]} */}
            {title?.includes('Broadband')
              ? _SERVICE_ACTIVATION_MESSAGE_.BBCompleted
              : _SERVICE_ACTIVATION_MESSAGE_.CVECompleted}
            {_SERVICE_ACTIVATION_MESSAGE_.common}
            <ExternalLink
              className={styles.link}
              link={SETUP_GUIDE_LINK_URL}
              withIcon={false}
              text={SETUP_GUIDE_LINK_TEXT}
              analytics={SETUP_GUIDE_LINK_ANALYTICS}
            />
          </p>
        </>
      );

    case SERVICE_ACTIVATION_PRODUCT_STATUSES.nonHaloIncomplete:
      return (
        <>
          <div style={{ marginBottom: '12px' }}>
            Scheduled date: <strong>{formattedDate}</strong>
          </div>
          <p>
            {_SERVICE_ACTIVATION_MESSAGE_[status][0]}
            {_SERVICE_ACTIVATION_MESSAGE_[status][1]}
          </p>
        </>
      );
    case SERVICE_ACTIVATION_PRODUCT_STATUSES.nonHaloCompleted:
      return (
        <>
          <div style={{ marginBottom: '12px' }}>
            Service went live: <strong>{formattedDate}</strong>
          </div>
          <p>{_SERVICE_ACTIVATION_MESSAGE_[status]}      <ExternalLink
            className={styles.link}
            link={SETUP_GUIDE_LINK_URL}
            withIcon={false}
            text={SETUP_GUIDE_LINK_TEXT}
            analytics={SETUP_GUIDE_LINK_ANALYTICS}
          /></p>

        </>
      );
    default:
      return null;
  }
};
